module.exports = __webpack_public_path__ + "assets_1773798366357/img/logo.71acd534.png";